import styled from 'styled-components';

import { Comment } from './Comment';

const StyledCommments = styled.div`
  .comment-container {
    &:not(:first-of-type) {
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
  }
`;

export const Comments = ({
  auth,
  articleId,
  commentId,
  allowReply,
  className,
  commentList = [],
  onUpdate
}) => {
  const filterComments = (list, articleId, commentId) => {
    const results = list.filter((comment) => {
      let comparison = comment.articleId == articleId;

      if (commentId) {
        return comparison && comment.commentId == commentId;
      } else {
        return comparison && comment.commentId == undefined;
      }
    });

    return results;
  };

  if (!filterComments(commentList, articleId, commentId).length) return null;

  return (
    <StyledCommments className={className}>
      {filterComments(commentList, articleId, commentId).map((comment) => {
        return (
          <div className="comment-container" key={`comment-${comment._id}-${articleId}`}>
            <Comment auth={auth} comment={comment} allowReply={allowReply} onReply={onUpdate}>
              {!commentId && (
                <Comments
                  auth={auth}
                  articleId={articleId}
                  commentId={comment._id}
                  allowReply={false}
                  className="replies"
                  commentList={commentList}
                  onUpdate={onUpdate}
                />
              )}
            </Comment>
          </div>
        );
      })}
    </StyledCommments>
  );
};
